/**
 * Created by vsuthar on 9/13/21
 * File: LicenseEmptyScreen
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { NoIntegrationSVG, Body, Bold, Button } from '@panwds/react-ui'
import Page from '../../../common/components/page/Page'
import './LicenseEmptyScreen.scss'
import { FF_DISABLE_LICENSE_TABLE_EDIT } from '../../../common/utils/FeatureFlags'
import { getVarValue } from '../../../common/utils/Sparky'
import {
  BUTTON_ADD_LICENSE_PRODUCT,
  BUTTON_ADD_SUB_TENANT,
  TENANCY_LICENSE_NO_LICENSE_PRODUCT,
  TENANCY_NO_DATA_DESCRIPTION
} from '../../constants/LabelConstants'
import { ROOT_NODE_ID } from '../../constants/TenancyConstants'
import useReadOnly from '../../../common/hooks/useReadOnly'
import { TENANCY_PERMISSION_SET, TSG_NONE } from '../../../common/constants/GlobalConstants'
import TooltipButton from '../../../common/components/tooltipButton/TooltipButton'
import {
  TOOLTIP_READ_ONLY
} from '../../../iam/constants/LabelConstants'


/**
 * When there are no license. Render this screen
 * @param selectedTreeNode
 * @param onAddLicenseProduct
 * @param onAddSubTenant
 * @returns {JSX.Element}
 * @constructor
 */
const LicenseEmptyScreen = ({ selectedTreeNode, onAddLicenseProduct, onAddSubTenant, onAddLicenses, isCgxPresent, globalTsgId, ...rest }) => {

  const readOnly = useReadOnly(selectedTreeNode?.id, TENANCY_PERMISSION_SET)
  const disableEditIcon = getVarValue(FF_DISABLE_LICENSE_TABLE_EDIT, false)

  return (<Page pageHeaderProps={{ title: '', subTitle: '', level: 2, size: 'xs' }}>
    <div className={'tw-flex tw-flex-col tw-flex-1 tw-items-center'}>
      <div style={{ height: 178, width: 178 }}>
        <NoIntegrationSVG />
      </div>
      <Body><Bold>{TENANCY_LICENSE_NO_LICENSE_PRODUCT}</Bold></Body>
      <Body appearance={'secondary'}>{TENANCY_NO_DATA_DESCRIPTION}</Body>
      {/*{isCgxPresent && <div className="license-box tw-text-center tw-pt-2 tw-my-2 ">*/}
      {/*  <Body size='sm' addClassName='tw-text-gray-600'>{SDWAN_ALLOCATION}</Body>*/}
      {/*  <div className="license-arrow license-arrow-bottom"/>*/}
      {/*</div>}*/}
      <div className={'tw-flex tw-flex-row tw-gap-3 tw-mt-3 tw-pl-10'}>
        {rest.showSubscriptions && globalTsgId !== TSG_NONE.id && !disableEditIcon && <Button disabled={readOnly} onClick={onAddLicenses} appearance={'primary'}>{BUTTON_ADD_LICENSE_PRODUCT}</Button>}
        {readOnly ? (
          <TooltipButton
            label={ TOOLTIP_READ_ONLY }
            disabled
            tooltipProps={{ defaultPlacement: 'bottom-end' }}
            buttonProps = {{ appearance: 'primary' }}>
            {BUTTON_ADD_SUB_TENANT}
          </TooltipButton>
        ) : (
          <Button disabled={selectedTreeNode?.id === ROOT_NODE_ID} onClick={onAddSubTenant} appearance={'primary'}>{BUTTON_ADD_SUB_TENANT}</Button>
        )}
      </div>
    </div>
    {/*<Card addClassName='tw-w-full' style={{ height: 90 }}>*/}
    {/*  <CardBody>*/}
    {/*    <div className='tw-flex tw-flex-row tw-w-1/2 tw-p-1 tw-relative'>*/}
    {/*      <div style={{ height: 64.2, width: 43.76 }}>*/}
    {/*        <NoIntegrationSVG />*/}
    {/*      </div>*/}
    {/*      <Body size='md' addClassName='tw-pl-6 tw-pt-3 tw-mr-8'>*/}
    {/*        <Title size='xxs' addClassName='tw-text-gray-900'>*/}
    {/*          {StringTemplate(LABEL_SUMMARY_NO_LICENSE_FOR_NODE, [selectedTreeNode?.display_name])}*/}
    {/*        </Title>*/}
    {/*      </Body>*/}
    {/*      <div className='tw-flex tw-flex-col tw-pt-3 tw-items-center'>*/}
    {/*        {rest.showSubscriptions && <Body size='md' addClassName='tw-justify-right tw-text-blue-600 tw-pl-8'>*/}
    {/*          <Bold><a onClick={onAddLicenses}>{BUTTON_ADD_LICENSE_PRODUCT}</a></Bold></Body>}*/}
    {/*        {isCgxPresent && <div className="box tw-text-center tw-absolute tw-p-2" style={{ bottom: -20 }}>*/}
    {/*          <Body size='sm' addClassName='tw-text-gray-600 tw-ml-6'>{ACTIVATE_SDWAN}</Body>*/}
    {/*          <div className="arrow arrow-top"/>*/}
    {/*        </div>}*/}
    {/*      </div>*/}
    {/*    </div>*/}
    {/*  </CardBody>*/}
    {/*</Card>*/}
  </Page>)
}

LicenseEmptyScreen.propTypes = {}
export default LicenseEmptyScreen

